import { feedbackAction } from "../const";

export const getFeedback = (payload: any) => {
    return {
        type: feedbackAction.FEEDBACK_ACTION,
        payload: payload,
    };
};
